module.exports = __webpack_public_path__ + "static/media/RP-A_S_Jacquard_Palestro_DK Grey_Bordeaux.308619d1.png";